<script setup lang="ts">
const props = defineProps<{
  error: {
    statusCode?: number
    statusMessage?: string
    message?: string
  }
}>()

const { t } = useI18n()

const bucket = computed<403 | 404 | 500>(() => {
  if (props.error.statusCode === 403) return 403
  if (props.error.statusCode === 404) return 404
  return 500
})

const titleKey = computed(() => `error_page_${bucket.value}_title`)
const bodyKey = computed(() => `error_page_${bucket.value}_body`)
const headTitle = computed(() => `Cardo Ride - ${t(titleKey.value)}`)

const goHome = () => clearError({ redirect: '/' })
const reload = () => window.location.reload()
</script>

<template>
  <NavigationTopBar />

  <Head>
    <Title>{{ headTitle }}</Title>
  </Head>

  <div
    class="tw-flex tw-min-h-[70vh] tw-items-center tw-justify-center tw-px-6 tw-py-16 sm:tw-py-24"
  >
    <div class="tw-flex tw-max-w-md tw-flex-col tw-items-center tw-text-center">
      <h1 class="tw-mb-3 tw-text-3xl tw-font-bold tw-text-gray-900 sm:tw-text-4xl">
        {{ t(titleKey) }}
      </h1>

      <p class="tw-mb-8 tw-text-base tw-leading-relaxed tw-text-gray-600">
        {{ t(bodyKey) }}
      </p>

      <div class="tw-flex tw-flex-col-reverse tw-gap-3 sm:tw-flex-row">
        <button
          type="button"
          :class="[
            'tw-rounded-full tw-border-0 tw-px-6 tw-py-2.5 tw-text-sm tw-font-medium tw-transition',
            bucket === 500
              ? 'tw-bg-transparent tw-text-gray-700 hover:tw-bg-gray-100'
              : 'tw-bg-riser-blue tw-text-white hover:tw-opacity-90'
          ]"
          @click="goHome"
        >
          {{ t('error_page_cta_home') }}
        </button>
        <button
          v-if="bucket === 500"
          type="button"
          class="tw-rounded-full tw-border-0 tw-bg-riser-blue tw-px-6 tw-py-2.5 tw-text-sm tw-font-medium tw-text-white tw-transition hover:tw-opacity-90"
          @click="reload"
        >
          <FontAwesomeIcon icon="rotate-right" class="tw-mr-2" />
          {{ t('error_page_500_cta_retry') }}
        </button>
      </div>

      <p
        v-if="error.statusCode"
        class="tw-mt-10 tw-text-xs tw-uppercase tw-tracking-wider tw-text-gray-400"
      >
        Error {{ error.statusCode }}
      </p>
    </div>
  </div>
</template>
